export default __webpack_public_path__ + "d96895e645255b278a5daa9e6e1e2ade.svg";